<template>
  <v-app>
    <AppBar v-if="insideDashboard"/>
    <router-view name="drawer"/>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

import AppBar from '@/components/core/AppBar/AppBar'

export default {
  name: 'App',

  components: {
    AppBar
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),

    insideDashboard () {
      return !this.$route.path.includes('login') &&
      !this.$route.path.includes('activate') &&
      !this.$route.path.includes('forgotPassword') &&
      !this.$route.path.includes('reset') &&
      this.userInfo !== null
    }
  }
}

</script>
<style lang="sass">
  @import url('https://fonts.googleapis.com/css?family=Inconsolata|Oswald')

  html
    font-size: 12px
    font-family: 'Inconsolata'
    overflow-y: auto
</style>
